
import { axiosInstance } from "@/lib/axiosInstance";
import config from "@/lib/config";
import axios from "axios";

export async function updateCategory(
  _id: string,
  updatedCategory: any
): Promise<any> {
  try {
    const response = await axiosInstance.patch(
      `${config.apiUrl}/categories/${_id}`,
      updatedCategory
    );
    return response.data.data;
  } catch (error) {
    if (axios.isAxiosError(error)) {
      throw new Error(
        error.response?.data.message || "Error updating Category"
      );
    } else {
      throw new Error("An unknown error occurred");
    }
  }
}
